export default "__VITE_ASSET__uyW7Up5M__"